import { render, staticRenderFns } from "./AssessmentRegStatusCallback.vue?vue&type=template&id=7736c0d9&scoped=true"
import script from "./AssessmentRegStatusCallback.vue?vue&type=script&lang=js"
export * from "./AssessmentRegStatusCallback.vue?vue&type=script&lang=js"
import style0 from "./AssessmentRegStatusCallback.vue?vue&type=style&index=0&id=7736c0d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7736c0d9",
  null
  
)

export default component.exports